const hideStagingFields = [
  'description',
  'custom_fields.cf_company',
  'priority',
  'custom_fields.cf_type_of_exporter_account',
  'product_id',
  'custom_fields.cf_reference_number',
  'type',
  'custom_fields.cf_question_type',
  'custom_fields.cf_request_source'
]

const stagingFields = {
  cf_request_source: 'SCF Portal' // request source
}

export const freshdeskMixin = {
  methods: {
    showAndPrefillFreshdesk(customFields) {
      const { email, currentExporter } = this.$store.getters
      const account = currentExporter
      window.FreshworksWidget('show')
      window.FreshworksWidget('show', 'launcher')
      window.FreshworksWidget('hide', 'ticketForm', [
        'name',
        'email',
        'subject',
        'custom_fields.cf_am_email',
        'custom_fields.cf_cs_email',
        'custom_fields.cf_importer_id',
        'custom_fields.cf_exporter_id',
        'custom_fields.cf_invoice_id',
        'custom_fields.cf_client_id',
        'custom_fields.cf_spam',
        'custom_fields.cf_query_channel',
        'custom_fields.cf_internal_channel',
        'custom_fields.cf_exporter_name',
        'custom_fields.cf_importer_name',
        'custom_fields.cf_invoice_reference',
        'custom_fields.cf_link_to_dashboard',
        'custom_fields.cf_category_i',
        'custom_fields.cf_portal_source',
        'custom_fields.description',
        ...hideStagingFields
      ])
      window.FreshworksWidget('prefill', 'ticketForm', {
        email: email,
        subject: `Support Ticket | ${account.company} | Drip Capital`,
        custom_fields: {
          cf_exporter_id: null,
          cf_exporter_name: '',
          cf_importer_id: account.id,
          cf_importer_name: account.company,
          cf_client_id: null,
          cf_invoice_id: null,
          cf_invoice_reference: '',
          cf_am_email: account.am.email || 'NOT ADDED',
          cf_cs_email: account.cs.email || '',
          cf_spam:
            process.env.VUE_APP_ENVIRONMENT === 'production'
              ? 'Non Spam'
              : 'Spam',
          cf_category_i: null,
          cf_query_channel: 'SCF Portal',
          cf_portal_source: 'SCF Portal', // request source
          ...stagingFields,
          ...customFields
        }
      })
    },
    hideFreshdeskWidget() {
      window.FreshworksWidget('hide', 'launcher')
    }
  }
}
